import { KontenbaseClient } from "@kontenbase/sdk";

export const getKontenbaseClient = () => 
	 new KontenbaseClient({ apiKey: `${process.env.REACT_APP_KONTENBASE_API_KEY}` })
